import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import { CandidateDetails } from "../../../../types/candidate";
import { CandidateOverviewCard } from "../../../../components";
import { LanguagesIcon, ExperienceIcon } from "../../../../assets/icons/candidate-details-page-icons";

const CandidateOverview = ({ candidateDetails }: { candidateDetails: CandidateDetails }) => {
  const { t } = useTranslation("goHire", { keyPrefix: "candidateDetailsPage.overviewTab" });

  const getIcon = (key: string): JSX.Element | null => {
    switch (key) {
      case "experience":
        return <ExperienceIcon />;
      case "languages":
        return <LanguagesIcon />;
      default:
        return null;
    }
  };

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("candidateOverview")}</Typography>
      <Box sx={styles.cardsContainer}>
        {candidateDetails.candidateOverview.map(({ key, value }: { key: string; value: string }) => (
          <CandidateOverviewCard key={key} title={key} value={value} icon={getIcon(key)} />
        ))}
      </Box>
    </Box>
  );
};

export default CandidateOverview;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",

    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "#FFF",
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
  },
  cardsContainer: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    gap: "8px",
  },
};
